import { Suspense } from 'react'
import { createBrowserRouter } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import { LocaleProvider } from './i18n/i18n'
import routes from './routes'

export default function App (props) {
  return (
    <Suspense>
      <LocaleProvider>
        <RouterProvider router={createBrowserRouter(routes)} />
      </LocaleProvider>
    </Suspense>
  )
}
